/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * FE_PTVang (ptvang@rsupartners.com)
 *
 * @description
 *
 * @created at Sun Dec 29 2024
 **/

export const MAX_SCALE = 2;

export const MIN_SCALE_MOBILE = 1;

export const MAX_SCALE_MOBILE = 4;

export const DISTANCE_TO_SCREEN_EDGE = window.innerWidth * 0.05;

export const MARGIN_TO_SCREEN_EDGE = 64;

export const HEIGHT_HEADER = 60;

export const FILE_GAP = 24;

export const SCROLL_HORIZONTAL_WIDTH_DETECTION = -110;
